import { get } from 'lodash';
import { getMyAchieveRewardsDXP, getRewardMemDetailDXP, claimRewardDXP } from '@/services';
import { normalizeDXPRewardList, showModelError } from '@/utils/rewardModel';

export default {
  namespace: 'myAwards',
  state: {
    myAwardsList: [],
    myAwardsDetail: {},
    myAwardsDetailTemp: {},
  },
  reducers: {
    save(state, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {
    *getMyAchieveRewardsDXP({ payload }, { put, call }) {
      try {
        const resp = yield call(getMyAchieveRewardsDXP, payload);
        const data = get(resp, 'data');
        const code = get(resp, 'resultCode');
        const retDesc = get(resp, 'resultMsg');
        // 0表示成功
        if (code === '0') {
          const myRewardsList = normalizeDXPRewardList(data);
          yield put({
            type: 'save',
            payload: {
              myAwardsList: myRewardsList || [],
            },
          });
          return myRewardsList || {};
        }
        return showModelError(retDesc, {});
      } catch (e) {
        return showModelError(e.Error, {});
      }
    },
    *claimRewardDXP({ payload }, { call }) {
      try {
        const resp = yield call(claimRewardDXP, payload);
        const data = get(resp, 'data');
        const code = get(resp, 'resultCode');
        const retDesc = get(resp, 'resultMsg');
        // 0表示成功
        if (code === '0') {
          return data;
        }
        return showModelError(retDesc, null);
      } catch (e) {
        return showModelError(e.Error, null);
      }
    },
    *claimEshopRewardDXP({ payload }, { call }) {
      try {
        let resp = yield call(claimRewardDXP, payload);
        resp = {
          ...resp,
          retCode: resp.resultCode,
          retDesc: resp.resultMsg,
          data: {
            ...(resp?.data || {}),
            promotionMediaItemDtoList: resp?.data?.mediaItemList,
          },
        };
        // const data = get(resp, 'data');
        // const code = get(resp, 'retCode');
        // const retDesc = get(resp, 'retDesc');
        // // 0表示成功
        // if (code === '0') {
        //   return data;
        // }
        // Toast.show({ icon: 'fail', content: retDesc });
        // return null;
        return resp;
      } catch (e) {
        // Toast.show({ icon: 'fail', content: e.Error });
        return {};
      }
    },
    *getRewardMemDetailDXP({ payload }, { put, call }) {
      try {
        const resp = yield call(getRewardMemDetailDXP, payload);
        let data = get(resp, 'data');
        const code = get(resp, 'resultCode');
        const retDesc = get(resp, 'resultMsg');
        data = {
          ...data,
          orderId: data.orderNbr,
          prcResSn: data.couponSn,
          prcResPwd: data.couponPwd,
          prcResExpDate: data.expDate,
          couponId: data.couponSn,
          keyId: data.rewardInstanceId,
          validDays: data.validityPeriod,
          receiveDeadDate: data.deadLine,
        };
        // 0表示成功
        if (code === '0') {
          yield put({
            type: 'save',
            payload: {
              myAwardsDetail: data || {},
            },
          });
          return data || {};
        }
        return showModelError(retDesc, {});
      } catch (e) {
        return showModelError(e.Error, {});
      }
    },
  },
};
